import { createEvent, createStore } from 'effector';
import { generalEnv } from '@nx-frontend/shared/env';
import { OrgInfo, OrgInfoSubscriptionType, OrganizationPrivilege } from '@nx-frontend/shared/types';

export const initialOrgInfoState: OrgInfo = {
  orgId: '',
  subscriptionType: OrgInfoSubscriptionType.STANDARD,
  subscriptionTypeSrc: '',
  type: '',
  isPremium: false,
  sub: '',
  domain: '',
  title: '',
  smallLogoStoredFileUUID: null,
  bigLogoStoredFileUUID: null,
  domainShorter: false,
  subscriptionPrivileges: [],
  isShareAdEnabled: false,
};

export const $orgInfo = createStore(initialOrgInfoState);

export const $orgInfoSubscriptionType = $orgInfo.map((state) => state.subscriptionType);

export const $isFreePlan = $orgInfo.map((orgInfo) =>
  [OrgInfoSubscriptionType.STANDARD].includes(orgInfo.subscriptionType)
);

export const setOrgInfoEvent = createEvent<OrgInfo>();

$orgInfo.on(setOrgInfoEvent, (_, newOrgInfo) => newOrgInfo);

export const $canSetPublicPagePassword = $orgInfo.map((orgInfo) => {
  return orgInfo?.subscriptionPrivileges?.includes(OrganizationPrivilege.CAN_SET_PUBLIC_PAGE_PASSWORD) || false;
});

export const $isCanManageDomain = $orgInfo.map((orgInfo) => {
  return orgInfo?.subscriptionPrivileges?.includes(OrganizationPrivilege.CAN_MANAGE_DOMAIN) || false;
});

export const $hasCname = $orgInfo.map((orgInfo) => {
  return !orgInfo?.domain?.includes(generalEnv?.nimbusDomain) || false;
});
